import React from "react";
import CountUp from "react-countup";
import Link from "next/link";
import { Grid } from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import styles from "./hero.module.scss";

export const UniPageAnalyticsHero = () => {
  return (
    <section className={styles.section_hero}>
      <div className="container">
        <Grid container spacing={3} alignItems="center">
          <Grid item sm={12} md={6}>
            <h1 className={styles.title}>
              Our Complete Recruitment Toolkit for Universities
            </h1>
            <p className={`${styles.sub_title}`}>
              Our university partners hone their distinct enrollment channels
              with multidimensional tools, enabling diverse opportunities to
              create recruitment success.
            </p>

            <div className={styles.button_wrapper}>
              <Link legacyBehavior href="/university/booking">
                <a className="btn btn-bg btn-secondary">Book for Demo</a>
              </Link>
            </div>
          </Grid>
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/uni_hero_analytics.png")}
                alt="University analytics"
              />
            </div>
          </Grid>
        </Grid>

        {/* <div className={styles.counter_wrapper}>
          <ul>
            <li>
              <div className={styles.number}>
                <CountUp end={4000} duration={2} />+
              </div>
              <div className={styles.text}>Agents</div>
            </li>
            <li>
              <div className={styles.number}>
                <CountUp end={15000} duration={2} />
              </div>
              <div className={styles.text}>Students</div>
            </li>
            <li>
              <div className={styles.number}>
                <CountUp end={20} duration={2} />+
              </div>
              <div className={styles.text}>Contries</div>
            </li>
            <li>
              <div className={styles.number}>
                <CountUp end={800000} duration={2} />+
              </div>
              <div className={styles.text}>Search courses</div>
            </li>
          </ul>
        </div>
         */}
      </div>
    </section>
  );
};

export default UniPageAnalyticsHero;
